import { Link } from "react-router-dom";
import { getFileUrl } from "../../../utils/helper";

const BlogCard = ({ blog }) => {
  return (
    <Link to={`/blogs/${blog.slug}`} className="group">
      <div className="relative h-[420px] rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">

        <img
          src={getFileUrl(blog.thumbnail, "blog")}
          alt={blog.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />

        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent"></div>

        <div className="absolute bottom-0 p-5 text-white w-full">
          <h3 className="text-2xl font-bold leading-snug line-clamp-3 mb-3">
            {blog.title}
          </h3>

          <p className="text-sm text-gray-200 line-clamp-2 mb-4">
            {blog.short_description}
          </p>

          <div className="flex items-center justify-between text-xs text-gray-300 border-t border-white/20 pt-3">
            <span className="uppercase tracking-wide">
              {blog.category || "मुंबई मित्र"}
            </span>
            <span className="text-indigo-300 font-medium">
              Read More →
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default BlogCard;
